import PropTypes from 'prop-types';
export var typeDs = PropTypes.oneOfType([PropTypes.object, PropTypes.func]);
export var typeSiteId = PropTypes.number;
export var typeWeixinAppid = PropTypes.number;
export var typeLocation = PropTypes.shape({
  key: PropTypes.string,
  pathname: PropTypes.string,
  search: PropTypes.string,
  hash: PropTypes.string,
  state: PropTypes.any
});
export var typeLink = PropTypes.shape({
  title: PropTypes.string,
  description: PropTypes.string,
  picUrl: PropTypes.string,
  url: PropTypes.string,
  linkType: PropTypes.string,
  linkIds: PropTypes.arrayOf(PropTypes.string)
});